import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { ValidationErrors } from '@angular/forms';

@Injectable()
export class LogoValidationService {
  public validatePDFLogo(files: File[]): Observable<ValidationErrors> {
    return from(
      new Promise((res) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result as string;
          image.onload = () => {
            const { height, width } = image;
            if (height < 44 || width < 44) {
              res({ error: 'Height and Width must not be less than 44px.' });
            }
            if (height > width) {
              res({ error: 'Height must not be bigger than Width.' });
            }
            res({});
          };
        };
      })
    );
  }
}
